import { mixpanelProjectKeys } from '@/config/constants';
import { useGlobalStore } from '@/stores/global';
import mixpanel from 'mixpanel-browser';
import type { App } from 'vue';

export const MixpanelInstance = mixpanel;

let isInitialized = false;
export function isMixpanelInitialized() {
  return isInitialized;
}

export async function initMixpanel(
  authUuid: string | undefined,
  authEmail: string | undefined,
  userRole: string,
) {
  // set project key to use, depends of execution environment
  const projectKey =
    useGlobalStore().mixpanel === 'production'
      ? mixpanelProjectKeys.production
      : mixpanelProjectKeys.test;

  MixpanelInstance.init(projectKey, {
    debug: true,
    api_host: useGlobalStore().mixpanel_proxy,
    loaded: () => {
      MixpanelInstance.register({
        email: authEmail,
        user_uuid: authUuid,
        user_role: userRole,
      });

      MixpanelInstance.identify(authUuid);

      MixpanelInstance.set_config({
        batch_flush_interval_ms: 1000,
      });

      isInitialized = true;
    },
  });
}

export default {
  install: (app: App) => {
    app.config.globalProperties.$mixpanel = MixpanelInstance;
    app.provide('mixpanel', MixpanelInstance);
  },
};
